/* Quencher-Shop: Kaufblock, Set-Wahl, Sticky-Leiste, Farb-/Set-Links */
(function () {
  var hero = document.querySelector('[data-qs-hero]');
  var cfgEl = hero && hero.querySelector('[data-qs-config]');
  if (!cfgEl) return;

  var cfg = JSON.parse(cfgEl.textContent);
  var keys = Object.keys(cfg.colors);
  var state = { qty: cfg.defaultQty || 2, colors: [] };

  function firstAvailable() {
    for (var i = 0; i < keys.length; i++) if (cfg.colors[keys[i]].available) return keys[i];
    return keys[0];
  }
  var pref = cfg.colors[cfg.start] ? cfg.start : keys[0];
  var start = cfg.colors[pref].available ? pref : firstAvailable();
  for (var i = 0; i < 3; i++) state.colors.push(start);

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function totals() {
    var cups = state.colors.slice(0, state.qty);
    var sum = 0;
    cups.forEach(function (k) { sum += cfg.colors[k].price; });
    var price, compare;
    if (state.qty === 1) {
      price = cfg.colors[cups[0]].price;
    } else {
      price = cfg.setPrices[state.qty - 1] || sum;
    }
    var uvp = (cfg.uvp || 0) * state.qty;
    compare = uvp > price ? uvp : 0;
    var available = cups.every(function (k) { return cfg.colors[k].available; });
    return { price: price, compare: compare, available: available };
  }

  function note() { return state.qty === 1 ? cfg.notes[0] : cfg.notes[1]; }

  var $ = function (sel, root) { return (root || hero).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function renderCups() {
    var box = $('[data-qs-cups]');
    if (!box) return;
    if (state.qty < 2 || keys.length < 2) { box.innerHTML = ''; return; }
    var html = '';
    for (var n = 0; n < state.qty; n++) {
      html += '<label class="qs-cup"><span>Becher ' + (n + 1) + '</span><select data-qs-cup="' + n + '">';
      keys.forEach(function (k) {
        var c = cfg.colors[k];
        html += '<option value="' + k + '"' + (state.colors[n] === k ? ' selected' : '') + (c.available ? '' : ' disabled') + '>' +
          c.label + (c.available ? '' : ' – ausverkauft') + '</option>';
      });
      html += '</select></label>';
    }
    box.innerHTML = html;
  }

  function render() {
    var t = totals();
    $('[data-qs-price]').textContent = money(t.price);
    var cmp = $('[data-qs-compare]'), cmpWrap = $('[data-qs-compare-wrap]'), save = $('[data-qs-save]');
    if (t.compare > t.price) {
      cmp.textContent = money(t.compare); cmpWrap.hidden = false;
      save.textContent = money(t.compare - t.price) + ' unter UVP'; save.hidden = false;
    } else { cmpWrap.hidden = true; save.hidden = true; }

    $$('[data-qs-qty]', hero).forEach(function (b) {
      var on = +b.getAttribute('data-qs-qty') === state.qty;
      b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on);
    });
    $$('[data-qs-color]', hero).forEach(function (b) {
      var on = b.getAttribute('data-qs-color') === state.colors[0];
      b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on);
    });
    $$('[data-qs-img]', hero).forEach(function (el) { el.hidden = el.getAttribute('data-qs-img') !== state.colors[0]; });

    var label = $('[data-qs-add-label]');
    var buttons = $$('[data-qs-add]', hero);
    if (t.available) {
      label.textContent = state.qty + ' Becher in den Warenkorb – ' + money(t.price);
      buttons.forEach(function (b) { b.disabled = false; });
    } else {
      label.textContent = 'Ausverkauft';
      buttons.forEach(function (b) { b.disabled = true; });
    }
    $('[data-qs-sticky-price]').textContent = money(t.price);
    $('[data-qs-sticky-label]').textContent = state.qty + ' Becher · ' + note();
    renderCups();
  }

  function setColor(k) {
    for (var i = 0; i < 3; i++) state.colors[i] = k;
    render();
  }
  function setQty(q) { state.qty = q; render(); }

  hero.addEventListener('click', function (e) {
    var c = e.target.closest('[data-qs-color]');
    if (c) { setColor(c.getAttribute('data-qs-color')); return; }
    var q = e.target.closest('[data-qs-qty]');
    if (q) { setQty(+q.getAttribute('data-qs-qty')); return; }
    var a = e.target.closest('[data-qs-add]');
    if (a) addToCart(a);
  });
  hero.addEventListener('change', function (e) {
    var s = e.target.closest('[data-qs-cup]');
    if (!s) return;
    state.colors[+s.getAttribute('data-qs-cup')] = s.value;
    render();
  });

  function scrollToBuy() {
    var target = document.getElementById('kaufen');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var pc = e.target.closest('[data-qs-pick-color]');
    var pq = e.target.closest('[data-qs-pick-qty]');
    if (!pc && !pq) return;
    e.preventDefault();
    if (pc) setColor(pc.getAttribute('data-qs-pick-color'));
    if (pq) setQty(+pq.getAttribute('data-qs-pick-qty'));
    scrollToBuy();
  });

  /* Warenkorb */
  function openCart(cart) {
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
    if (typeof window.openCartDrawer === 'function' && typeof window.createCartItems === 'function') {
      window.createCartItems(cart); window.openCartDrawer(); return;
    }
    window.location.href = '/cart';
  }
  function updateCount(cart) {
    $$('[data-qs-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
    });
  }
  function addToCart(btn) {
    var t = totals();
    if (!t.available) return;
    var err = $('[data-qs-error]');
    err.hidden = true;
    var counts = {};
    state.colors.slice(0, state.qty).forEach(function (k) {
      var id = cfg.colors[k].id; counts[id] = (counts[id] || 0) + 1;
    });
    var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCount(cart); openCart(cart);
    }).catch(function (j) {
      err.textContent = (j && (j.description || j.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      err.hidden = false;
    }).then(function () { btn.classList.remove('is-loading'); });
  }

  $$('[data-qs-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (typeof window.upcartOpenCart === 'function') { e.preventDefault(); window.upcartOpenCart(); }
    });
  });

  /* Sticky-Leiste: sichtbar, sobald der Kauf-Button aus dem Bild ist (nur mobil per CSS) */
  var sticky = $('[data-qs-sticky]');
  var mainBtn = $('.qs-btn--buy');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var btnVisible = true;
    var update = function () {
      var show = !btnVisible && window.scrollY > 10;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var sb = sticky.querySelector('button');
      if (sb) sb.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      btnVisible = entries[0].isIntersecting; update();
    }).observe(mainBtn);
    window.addEventListener('scroll', update, { passive: true });
  }

  render();
})();
